export const PRODUCT_WINDOW_TYPE = {
  SKU: 'SKU',
  TYPE: 'TYPE'
};
